module.exports = __webpack_public_path__ + "static/media/Arrow.a30b578f.svg";